import './main-section.scss';

/**
 * version    1.0
 * class      <type> (MainSection)
 * classdesc
 */
export class MainSection {}
